/**************
 Global
 ***************/

//add new product to cart
//let formData = { quantity: 1, id: 794864229, properties: { 'Personalize': 'ZHM' } };
function addProduct(formData) {
    return fetch(`${Shopify.routes.root}cart/add.js`, {
        method: "POST",
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
    })
        .then(data => data.json());
}

//change an existing product in your cart
//let formData = { quantity: 1, id: 794864229 } or items: [{ quantity: 1, id: 794864229 }]
function changeCart(formData) {
    return fetch(`${Shopify.routes.root}cart/change.js`, {
        method: "POST",
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
    })
        .then(data => data.json());
}

//update cart note or attributes (_ for attributes are hidden and __ are private)
//let formData = { note: 'This is a note about my order', attributes: { 'Gift wrap': 'Yes' } }
//let formData = {updates: { 794864229: 2, 794864230: 3 }}
function updateCart(formData) {
    return fetch(`${Shopify.routes.root}cart/update.js`, {
        method: "POST",
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
    })
        .then(data => data.json());
}

// download product
function downloadProduct(handle) {
    return fetch(`${Shopify.routes.root}products/${handle}.js`)
        .then(data => data.json());
}

// get cart
function getCart() {
    return fetch(`${Shopify.routes.root}cart.js`)
        .then(data => data.json());
}

// print price (515491 => $5,154.91)
function price(amountInCents, removeTrailingZeros = false) {
    // calculate total
    let total = (parseFloat(amountInCents) / 100).toFixed(2).toString();

    // add commas if needed
    total = total.replace(/\B(?=(\d{3})+(?!\d))/g, ",");

    // remove trailing zeros
    if (removeTrailingZeros) {
        total = total.toString().replace(".00", "");
    }

    // return total
    return `${currency}${total}`;
}

// sleep
function sleep(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
}

/**************
 Design mode open mini cart
 ***************/
if (Shopify.designMode) {
    // if a user clicks on the mini cart
    document.addEventListener('shopify:section:select', function (event) {
        // open mini cart
        if (event.detail.sectionId === 'theme-mini-cart') {
            openCart();
        }

        // if they deselect the mini cart
        if (event.detail.sectionId !== 'theme-mini-cart') {
            closeCart();
        }
    });
}

// scroll to url hash
const maltertechParams = new URLSearchParams(window.location.search);

if (maltertechParams.get("scroll_to_class")) {
    const element = document.querySelector(`.${maltertechParams.get("scroll_to_class")}`);
    if (element) {
        window.scrollTo({
            behavior: 'smooth',
            top: element.offsetTop - 120,
        })
    }
}

if (maltertechParams.get("scroll_to_id")) {
    const element = document.querySelector(`#${maltertechParams.get("scroll_to_id")}`);
    if (element) {
        window.scrollTo({
            behavior: 'smooth',
            top: element.offsetTop - 120,
        })
    }
}

// Function to send back in stock subscription to Klaviyo
async function sendKlaviyoBackInStockRequest(emailAddress, variantID) {
    await fetch(`https://a.klaviyo.com/client/back-in-stock-subscriptions?company_id=${await klaviyo.account()}`, {
        method: 'POST',
        headers: {
            accept: 'application/vnd.api+json',
            revision: '2024-10-15',
            'content-type': 'application/vnd.api+json'
        },
        body: JSON.stringify({
            data: {
                type: "back-in-stock-subscription",
                attributes: {
                    channels: ["EMAIL"],
                    profile: {
                        data: {
                            type: "profile",
                            attributes: {
                                email: emailAddress,
                            }
                        }
                    }
                },
                relationships: {
                    variant: {
                        data: {
                            type: "catalog-variant",
                            id: `$shopify:::$default:::${variantID}`,
                        }
                    }
                }
            }
        })
    })
}

/**
 *
 * Helper function that sets up popups with custom animations and remains ADA compliant.
 * Requires an open button with an aria-controls attribute matching the id of the dialog.
 * Expects the dialog element's first child to be a div, which contains the content of the popup.
 * Expects the close button in the dialog to have the class 'MTClosePopup'.
 * Tip: make the animation in and out classes the same name as the animations themselves.
 *
 * @param {HTMLDialogElement} modalElement - The dialog element for the modal.
 * @param {HTMLButtonElement} openButtonElement - Optional. The node to use as the open button. Defaults to a button that has the proper aria-controls attribute
 * @param {boolean} showModal - The modal function to trigger when open. Set to 'true' to call .showModal(), otherwise uses .show()
 * @param {string} animationInClass - The class that when assigned to the content of the modal runs an 'IN' animation.
 * @param {string} animationOutClass - The class that when assigned to the content of the modal runs an 'OUt' animation.
 * @param {boolean} [preventScroll=false] - Console logs each step of the function and associated data.
 * @param {boolean} [devMode=false] - Console logs each step of the function and associated data.
 * @returns {void}
 *
 * NOTES FOR DEV
 * - Change the open button so it can be an attribute passed in the function call, with a fall back of the document query
 *      for a button with the aria-controls attribute for the modal ID
 * -
 */
//ADD AN ESCAPE KEY LISTNER THAT PREVENTS DEFAULT AND RUNS THE ANIMATION
//ADD MTANIMATION CLASSES AS GLOBALS (LIKE SWIPER DOES).
function setupModal(modalElement,
                    openButtonElement = false,
                    showModal = true,
                    animationInClass,
                    animationOutClass,
                    preventScroll,
                    devMode = false
) {

    const modal = modalElement;
    const modalContent = modal.firstElementChild;
    const openButton = openButtonElement || document.querySelector(`button[aria-controls='${modal.id}']`)
    const closeButton = modal.querySelector(".mt-close-popup");

    //console.log(modal.parentNode);

    // Fail out if any elements are not what they are supposed to be.
    if (!(modal instanceof HTMLDialogElement)) {
        console.error("Modal element is not of object type HTMLDialogElement.");
        console.error(`Value passed for modalElement: ${modal}.`)
        return
    } else if (!(modalContent)) {
        console.error("Modal does not have a child element. A div that holds the popup content is recommended.");
        return;
    } else if (!(openButton instanceof HTMLButtonElement)) {
        console.error(`Open Button element is not of object type HTMLButtonElement. Make sure the element used as an Open Button has an 'aria-controls' attribute with the id of the popup you want it to control.`);
        console.error(`Value passed for openButtonElement: ${openButton}.`)
        return
    } else if (!(closeButton instanceof HTMLButtonElement)) {
        //console.error(`Close Button element is not of object type HTMLButtonElement. Make sure the close button has the class 'mt-close-popup', and the close button is a child of the modal's content.`);
        //console.error(`Value passed for closeButtonElement: ${closeButton}.`);
    } else if (typeof animationInClass !== "string" && typeof animationOutClass !== "string") {
        console.error(`Values passed for animationClasses are not of type "string"`);
        console.error(`Value passed for animationInClass: ( ${animationInClass} ) with type "${typeof animationInClass}".`);
        console.error(`Value passed for animationOutClass: ( ${animationOutClass} ) with type "${typeof animationOutClass}".`);
        return
    }

    //Animation listener to determine if we animated in or out
    modal.addEventListener("animationend", (e) => {
        if (e.animationName === `${animationInClass}` && e.target === modalContent) {
            modalContent.classList.remove(`${animationInClass}`);
        } else if (e.animationName === `${animationOutClass}` && e.target === modalContent) {
            modal.close();
            openButton.setAttribute("aria-expanded", "false");
            modalContent.classList.remove(`${animationOutClass}`);
            if (preventScroll) {
                document.body.style.overflow = "visible";
            }
        }
    });

    //Show the modal on openButton Click.
    openButton.addEventListener("click", (e) => {
        if (!modal.open) {
            if (openButton.contains(e.target)) {
                modalContent.classList.add(`${animationInClass}`);
                if (showModal) {
                    modal.showModal();
                } else {
                    modal.show();
                }
            }
            openButton.setAttribute("aria-expanded", "true");
            if (preventScroll) {
                document.body.style.overflow = "hidden";
            }
        } else {
            modalContent.classList.add(`${animationOutClass}`);
        }
    });

    //hide the modal if background is clicked
    modal.addEventListener("click", (e) => {
        if (e.target === modal) {
            modalContent.classList.add(`${animationOutClass}`);
        }
    });

    //Hide the modal on close button click
    if (closeButton) {
        closeButton.addEventListener("click", (e) => {
            if (closeButton.contains(e.target)) {
                modalContent.classList.add(`${animationOutClass}`);
            }
        });
    }

    //Hide the modal on escape key press
    modal.addEventListener("keydown", (e) => {
        if (e.key === "Escape") {
            e.preventDefault();
            modalContent.classList.add(`${animationOutClass}`);
        }
    })
}

function debounce(func, delay) {
    let timerId;

    return function (...args) {
        // 1. Clear any previous pending timer
        clearTimeout(timerId);

        // 2. Set a new timer to run the function after the delay
        timerId = setTimeout(() => {
            func.apply(this, args); // Preserves 'this' context and passes arguments
        }, delay);
    };
}